module.exports = __webpack_public_path__ + "static/pro-d28183021aadb22ce08d0557bdba8277.png";